<template>
  <label class="checkbox-container">
    <!-- 复选框 -->
    <input
        type="checkbox"
        :checked="checked"
        @change="$emit('change', $event.target.checked)"
        class="checkbox-input"
    />
    <span
        class="checkbox-box"
        :class="{ checked: checked }"
    ></span>

    <!-- 插槽内容 -->
    <slot></slot>
  </label>
</template>

<script>
export default {
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    checked: {
      type: Boolean,
      default: false
    }
  }
};
</script>
<style lang="less" scoped>
.checkbox-container {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
  font-size: 14px;

  .checkbox-input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  .checkbox-box {
    width: 16px;
    height: 16px;
    border: 1px solid #d0d1d2; // 默认边框
    border-radius: 3px; // 按比例调整圆角
    margin-right: 8px;
    transition: border-color 0.3s ease, background-color 0.3s ease;
    box-sizing: border-box;
    position: relative;
    &.checked {
      border-color: #29d769;
      background-color: #29d769;

      &::after {
        content: '';
        position: absolute;
        left: 4px;
        top: 1px;
        width: 4px;
        height: 8px;
        border: solid white;
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
      }
    }
  }
}
</style>

